import http from "./HttpService";

const apiEndPoint = "/nachricht/";

export const getAlleNachrichtenEndpoint = apiEndPoint;

export const countNachrichtenEndpoint = apiEndPoint + "count/";

export function setNachrichtGelesen(nachrichtId) {
    return http.patch(apiEndPoint + nachrichtId, null, { params: { gelesen: "true" } });
}

export function deleteNachricht(nachrichtId) {
    return http.delete(apiEndPoint + nachrichtId);
}
